import React, { useCallback, useRef, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Container,
  Col,
} from "reactstrap";
import { Link } from "react-router-dom";
import NotificationAlert from "react-notification-alert";

import { Form } from "@unform/web";
import * as Yup from "yup";
import logo from "../../../assets/img/autopilot-logo.png";
import getValidationErrors from "../../../utils/getValidationErrors";
import CustomInputGroupText from "components/CustomInputGroupText";
import { useToast } from "../../../hooks/toast";
import api from "../../../services/api";
import "../Login/login.css";

// PO1-2000 — fluxo "Esqueci minha senha".
// O backend responde sempre 200 com mensagem neutra (não vazar se o e-mail
// existe). Aqui sempre exibimos a mesma confirmação após envio.

const ForgotPassword = () => {
  const formRef = useRef(null);
  const alertRef = useRef();
  const { addToast } = useToast();
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = useCallback(
    async (data) => {
      try {
        formRef.current.setErrors({});
        const schema = Yup.object().shape({
          email: Yup.string()
            .email("Informe um e-mail válido")
            .required("E-mail é obrigatório"),
        });
        await schema.validate(data, { abortEarly: false });

        setSubmitting(true);
        await api.post("/auth/password-reset/request", { email: data.email });
        setSubmitted(true);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          formRef.current.setErrors(getValidationErrors(error));
          return;
        }
        addToast({
          place: "tr",
          type: "danger",
          title: "Erro",
          description:
            "Não foi possível processar a solicitação. Tente novamente.",
          icon: "tim-icons icon-alert-circle-exc",
        });
      } finally {
        setSubmitting(false);
      }
    },
    [addToast]
  );

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={alertRef} />
      </div>
      <div className="content">
        <Container>
          <Col className="ml-auto mr-auto" lg="4" md="6">
            <Card className="glass-card">
              <CardHeader>
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(255, 255, 255, 0.92)",
                    borderRadius: "16px",
                    width: "160px",
                    height: "80px",
                    marginBottom: "16px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
                  }}
                >
                  <img
                    alt="Everlog"
                    src={logo}
                    style={{ width: "140px", objectFit: "contain" }}
                  />
                </div>
                <h4>
                  {submitted ? "Verifique seu e-mail" : "Esqueci minha senha"}
                </h4>
              </CardHeader>

              {submitted ? (
                <>
                  <CardBody>
                    <p style={{ marginBottom: 0 }}>
                      Se o e-mail informado estiver cadastrado, você receberá
                      um link para redefinir a senha em alguns instantes. O
                      link expira em 30 minutos.
                    </p>
                  </CardBody>
                  <CardFooter>
                    <Link to="/auth/login">
                      <Button block className="btn-entrar mb-3" size="lg">
                        Voltar ao login
                      </Button>
                    </Link>
                  </CardFooter>
                </>
              ) : (
                <Form ref={formRef} onSubmit={handleSubmit}>
                  <CardBody>
                    <p style={{ marginBottom: 16 }}>
                      Informe o e-mail cadastrado e enviaremos um link para
                      redefinir sua senha.
                    </p>
                    <CustomInputGroupText
                      name="email"
                      type="email"
                      placeholder="E-mail"
                      addonType="prepend"
                      icon="tim-icons icon-email-85"
                    />
                  </CardBody>
                  <CardFooter>
                    <Button
                      block
                      className="btn-entrar mb-3"
                      size="lg"
                      type="submit"
                      disabled={submitting}
                    >
                      {submitting ? "Enviando..." : "Enviar link"}
                    </Button>
                    <div style={{ textAlign: "center" }}>
                      <Link to="/auth/login" style={{ color: "#fff" }}>
                        Voltar ao login
                      </Link>
                    </div>
                  </CardFooter>
                </Form>
              )}
            </Card>
          </Col>
        </Container>
      </div>
    </>
  );
};

export default ForgotPassword;
